import React from "react";
import PropTypes from "prop-types";
import { TextForm } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { FeedbackBox } from "@domestika-dev/prudencio/dist/molecules/FeedbackBox";
import { Box } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { IconForm } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { ThumbsUp, ThumbsDown } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { FormattedMessage } from "react-intl";

const FeedbackAlert = ({ sended, loading, isGood, feedbackAtion }) => (
  <FeedbackBox>
    <FeedbackBox.Wrapper display={["block", "block", "flex"]}>
      {sended && !loading && (
        <TextForm as="span" size="default" color="sonar">
          <FormattedMessage
            id={isGood ? "alerts.faqs.feedback.positive" : "alerts.faqs.feedback.negative"}
          />
        </TextForm>
      )}
      {!sended && !loading && (
        <>
          <TextForm as="span" size="default" color="sonar">
            <FormattedMessage id="alerts.faqs.feedback.description" />
          </TextForm>
          <Box display={["flex", "flex", "inline-flex"]}>
            <Button
              buttonType="text"
              marginLeft={[0, 0, 5]}
              size="none"
              action={() => feedbackAtion(true)}
            >
              <IconForm marginRight={[2]} size="default" color={isGood ? "manzana" : "sonar"}>
                <ThumbsUp />
              </IconForm>
              <TextForm
                size="default"
                as="span"
                fontWeight="medium"
                color={isGood ? "manzana" : "sonar"}
              >
                Sí
              </TextForm>
            </Button>
            <Button buttonType="text" marginLeft={[5]} size="none" action={() => feedbackAtion(false)}>
              <IconForm
                marginRight={[2]}
                size="default"
                color={isGood || isGood === null ? "sonar" : "rambutan"}
              >
                <ThumbsDown />
              </IconForm>
              <TextForm
                size="default"
                as="span"
                fontWeight="medium"
                color={isGood || isGood === null ? "sonar" : "rambutan"}
              >
                No
              </TextForm>
            </Button>
          </Box>
        </>
      )}
    </FeedbackBox.Wrapper>
  </FeedbackBox>
);

export default FeedbackAlert;

FeedbackAlert.propTypes = {
  sended: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  isGood: PropTypes.oneOfType([null, PropTypes.bool]).isRequired,
  feedbackAtion: PropTypes.func.isRequired,
};
